import Vue from 'vue'
import Vuex from 'vuex'
import axios from "axios";

Vue.use(Vuex)

export const GET_SESSION_DETAILS = 'getsessiondetails';

export const store = new Vuex.Store({
    state: {
        sessionDetails: null
    },
    getters: {
        sessionDetails: state => { return state.sessionDetails }
    },
    mutations: {
        setSessionDetails: (state, payload) => { state.sessionDetails = payload }
    },
    actions: {
        [GET_SESSION_DETAILS](context){
            var url = new URL(window.location.href);
            var redirectLink = url.searchParams.get("redirectLink");
            var redirectMessage = url.searchParams.get("redirectMessage");
            var isRedirectToNewTab = url.searchParams.get("isRedirectToNewTab");
            var redirectAutomaticMessage = url.searchParams.get("redirectAutomaticMessage");
            var isCountdown = url.searchParams.get("isCountdown");
            if(redirectLink && redirectMessage && isRedirectToNewTab && redirectAutomaticMessage && isCountdown){
                var sessionData = {
                    redirectLink : redirectLink,
                    redirectMessage : redirectMessage,
                    isRedirectToNewTab : isRedirectToNewTab,
                    redirectAutomaticMessage : redirectAutomaticMessage,
                    isCountdown : isCountdown
                }
                context.commit('setSessionDetails', sessionData);
            }else{
                return new Promise((resolve, reject) => {
                    axios.get("/api/getRedirectEnv").then(res => {
                        if (!res.data.error) {
                            context.commit('setSessionDetails', res.data);
                            resolve(res.data);
                        } else {
                            console.log(res.data);
                            reject(res.data.error);
                        }
                    }).catch(err => {
                        console.log('Exception :: setSessionDetails :: ' + err);
                        reject(err);
                    });
                });
            }
        }
    }
});